export default class Base {
    /**
     * Base data source object.
     *
     * The current {@link carto.source|sources} available are: {@link carto.source.Dataset|Dataset}, {@link carto.source.SQL|SQL}, {@link carto.source.GeoJSON|GeoJSON} and {@link carto.source.MVT|MVT}
     *
     * Use a source to reference the data used in a {@link carto.Layer|layer}.
     *
     * @constructor Base
     * @namespace carto.source
     * @abstract
     * @api
     */
}
